export default {
  UTRON_LOGO: require("./utron_logo.png"),
  UTRON_LOGO2: require("./utron_logo2.png"),
  CHARGING_POSITIONS: require("./charging_positions.png"),
  CAR_WITHOUT_CHARGING_PORTS: require("./car_without_charging_ports.png")
};
